import { render, staticRenderFns } from "./BedroomCount.vue?vue&type=template&id=e6813b64&"
import script from "./BedroomCount.vue?vue&type=script&lang=ts&"
export * from "./BedroomCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports